import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit
} from '@angular/core';

import { NgForm } from "@angular/forms";
import { AuthService, ProviderService } from '../../api';

import { UnavailabilityType } from '../../constants';
import { Errors, unAvailability, unAvailabilityTiming } from '../../interfaces';
import { SnackService } from '../../services';

@Component({
  selector: 'school-unavailability-form',
  templateUrl: './unavailability-form.component.html',
  styleUrls: ['./unavailability-form.component.scss'],
  providers: [DatePipe]
})
export class UnavailabilityFormComponent implements OnInit, OnDestroy, AfterViewInit {

  typeList:any = UnavailabilityType;
  availabilityFormValue = {} as unAvailability;
  errMsg = {} as Errors;

  today = new Date();

  @Input() formtype: any;
  @Input() user_id: any;
  @Output() accordionEvent = new EventEmitter();
  @Output()
  cancelEvent = new EventEmitter<string>();

  @ViewChild('inputfocus', { static: false }) inputs: ElementRef;

  @ViewChild("availabilityform", { static: false }) availabilitysform: NgForm;

  constructor(
    private authService: AuthService,
    private _snackService: SnackService,
    private _userService: ProviderService,
    private datePipe: DatePipe,
    ) { }

  ngOnInit(): void {
    this.availabilityFormValue.timing = {} as unAvailabilityTiming;

  }
  ngAfterViewInit() {
    this.inputs.nativeElement.focus();
  }



  ngOnDestroy(): void {
    this.accordionEvent.unsubscribe();
  }

  viewAvailabilitylist() {
    this.cancelEvent.emit();
  }


  checkTime(from_time, to_time) {
    var now = new Date();
    from_time = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + from_time;
    to_time = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + to_time;

    if (to_time > from_time) {
      return true;
    }
    else {
      return false;
    }
  }

  onSubmit(): void {


    const checkTimeValid = this.checkTime(this.availabilityFormValue.timing.from_time, this.availabilityFormValue.timing.to_time);

    if(checkTimeValid){


    this.availabilityFormValue.from_date = this.datePipe.transform(this.availabilityFormValue.from_date, 'y-MM-dd');

    if(this.user_id){
      this.availabilityFormValue.user_id = this.user_id;
    }

    // const timeval = JSON.parse(localStorage.getItem('userData'));

    // this.availabilityFormValue.timing.tz = timeval.timezone.zone_name;

    this.authService.user.subscribe(user => {

      const timeval = user;
      this.availabilityFormValue.timing.tz = timeval.timezone.zone_name;
    });

      const saveData = { ...this.availabilityFormValue };

      this._userService.saveUnavailability(saveData).subscribe(
        result => {

          this.availabilitysform.resetForm();
          this._snackService.openSnackBar("success", "Unavailability Added Successfully!...");
          this.errMsg = {};
          this.viewAvailabilitylist();

        }, error => {
          this._snackService.openSnackBar("danger", "Failed to add a new Unavailability...");
          this.errMsg = error.error.data.errors;
        });

    }
    else{
      this._snackService.openSnackBar("danger", "Invalid From time and To time...");

    }

  }


}
